import {
	ActionIcon,
	Box,
	Collapse,
	CopyButton,
	Tooltip,
	createStyles,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import MarkdownRenderer from '@repo/common/components/MarkdownRenderer';
import { Icon, Text } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	wrapper: {
		width: '100%',
	},
	collapseRow: {
		display: 'flex',
		alignItems: 'center',
		color: theme.other.getColor('surface/info/default'),
		cursor: 'pointer',
	},
	logBox: {
		position: 'relative',
		fontFamily: 'monospace',
		fontSize: '12px',
		backgroundColor: theme.other.getColor('surface/info/default'),
		padding: '10px',
		marginTop: '15px',
		marginBottom: '15px',
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-all',
		borderRadius: '10px',
		boxShadow: theme.shadows.md,
	},
	copyButton: {
		position: 'absolute',
		top: '5px',
		right: '5px',
	},
}));

interface ISuggestionBoxProps {
	title: string;
	message: string;
}

export function SuggestionBox({ title, message }: ISuggestionBoxProps) {
	const { classes } = useStyles();
	const [opened, { toggle }] = useDisclosure(true);

	let icon = <Icon name="chevronRight" />;

	if (opened) {
		icon = <Icon name="chevronDown" />;
	}

	const copyValue = JSON.stringify({
		title,
		message,
	});

	return (
		<Box className={classes.wrapper}>
			<Box className={classes.logBox}>
				<Box className={classes.collapseRow} onClick={toggle}>
					{icon}
					<Text size="sm" weight="bold">
						{title ?? 'Error'}
					</Text>
				</Box>
				<Collapse in={opened}>
					<MarkdownRenderer fontSize="13px">{message}</MarkdownRenderer>
				</Collapse>
				<CopyButton value={copyValue} timeout={2000}>
					{({ copied, copy }) => (
						<Box className={classes.copyButton}>
							<Tooltip
								label={copied ? 'Copied' : 'Copy full suggestion'}
								withArrow
								position="right"
							>
								<ActionIcon
									bg="transparent"
									color={copied ? 'red' : 'gray'}
									onClick={copy}
								>
									{copied ? <Icon name="check" /> : <Icon name="copy" />}
								</ActionIcon>
							</Tooltip>
						</Box>
					)}
				</CopyButton>
			</Box>
		</Box>
	);
}
